import "core-js/modules/es.function.name.js";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/rcmk4.jpg';
import _imports_1 from '@/assets/gslogo.png';
import _imports_2 from '@/assets/xin1.png';
import _imports_3 from '@/assets/as.png';
import _imports_4 from '@/assets/ewm.png';
import _imports_5 from '@/assets/gzh.jpg';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-8bc19b0c"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  style: {
    "margin": "auto",
    "display": "flex",
    "flex-direction": "row"
  }
};
var _hoisted_2 = {
  class: "center"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    style: {
      "width": "100%",
      "height": "100%"
    }
  })], -1);
});

var _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"fromstyle-wz\" data-v-8bc19b0c><span class=\"wz-zun\" data-v-8bc19b0c>尊敬的电子制造行业从业者：</span><span class=\"wz-nei\" data-v-8bc19b0c>回流焊焊接技术作为电子制造的关键环节，对产品质量和生产效率起着决定性的作用。为了进一步提升回流焊焊接技术的水平并推动行业的可持续发展， 我们诚挚地邀请您积极参与「<span style=\"font-weight:600;color:#000;\" data-v-8bc19b0c>回流焊焊接系统诊断与对策</span>」的问卷调研。 </span><span class=\"wz-nei\" data-v-8bc19b0c>此问卷旨在了解您的实际工作中在回流焊焊接过程中所面临的挑战和问题，以及您对于解决方案的期望和建议， 以求达到技术的创新和改进。只有通过广泛的合作和共同努力，我们才能够让回流焊焊接技术在不断发展中展现出更壮大。</span><span class=\"wz-nei\" data-v-8bc19b0c> 您的参与对于我们来说至关重要， 您所提供的每一个建议和想法都将为回流焊焊接技术的提升与创新增添一份力量。我们将认真对待您的每一份调查结果，对您的信息严格保密，以确保数据的准确性和安全性。 </span></div><div class=\"fromstyle-wz1\" data-v-8bc19b0c> 为感谢您的参与，我们将向前100位填写问卷的工程师分享本次焊接技术调研报告，及获得专家指导技术机会。该报告将为您提供全面深入的焊接技术知识和前沿研究动态，专家老师将用实战经验助力您在工作中取得更大的成功。 </div>", 2);

var _hoisted_6 = {
  class: "zheng"
};

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "one"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "one-right"
  }, [/*#__PURE__*/_createElementVNode("div", {
    style: {
      "margin": "auto"
    }
  }, "请先填写您的基本信息")])], -1);
});

var _hoisted_8 = {
  class: "bottom",
  style: {
    "padding-right": "15px"
  }
};
var _hoisted_9 = {
  class: "zheng"
};

var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "one"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "one-right"
  }, [/*#__PURE__*/_createElementVNode("div", {
    style: {
      "margin": "auto"
    }
  }, "1.您目前使用的回流炉是什么品牌？（多选）")])], -1);
});

var _hoisted_11 = {
  class: "bottom"
};

var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    style: {
      "margin-right": "10px"
    }
  }, "其它", -1);
});

var _hoisted_13 = ["disabled"];
var _hoisted_14 = {
  class: "zheng"
};

var _hoisted_15 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "one"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "one-right"
  }, [/*#__PURE__*/_createElementVNode("div", {
    style: {
      "margin": "auto"
    }
  }, "2.您目前使用的焊接工艺是什么？（多选）")])], -1);
});

var _hoisted_16 = {
  class: "bottom"
};

var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    style: {
      "margin-right": "10px"
    }
  }, "其它", -1);
});

var _hoisted_18 = ["disabled"];
var _hoisted_19 = {
  class: "zheng"
};

var _hoisted_20 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "one"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "one-right"
  }, [/*#__PURE__*/_createElementVNode("div", {
    style: {
      "margin": "auto"
    }
  }, "3.您所在的厂区回流炉设备数量有多少台？（单选）")])], -1);
});

var _hoisted_21 = {
  class: "bottom"
};

var _hoisted_22 = /*#__PURE__*/_createTextVNode("01-10台");

var _hoisted_23 = /*#__PURE__*/_createTextVNode("10-20台");

var _hoisted_24 = /*#__PURE__*/_createTextVNode("20-40台");

var _hoisted_25 = /*#__PURE__*/_createTextVNode("40-60台");

var _hoisted_26 = /*#__PURE__*/_createTextVNode("60台以上");

var _hoisted_27 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    style: {
      "margin-right": "10px"
    }
  }, "其它", -1);
});

var _hoisted_28 = ["disabled"];
var _hoisted_29 = {
  class: "zheng"
};

var _hoisted_30 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "one"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "one-right"
  }, [/*#__PURE__*/_createElementVNode("div", {
    style: {
      "margin": "auto"
    }
  }, "4.您的回流炉设备使用了多久？（单选）")])], -1);
});

var _hoisted_31 = {
  class: "bottom"
};

var _hoisted_32 = /*#__PURE__*/_createTextVNode("0-1年");

var _hoisted_33 = /*#__PURE__*/_createTextVNode("1-3年");

var _hoisted_34 = /*#__PURE__*/_createTextVNode("3-5年");

var _hoisted_35 = /*#__PURE__*/_createTextVNode("5年以上");

var _hoisted_36 = {
  class: "zheng"
};

var _hoisted_37 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "one"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "one-right"
  }, [/*#__PURE__*/_createElementVNode("div", {
    style: {
      "margin": "auto"
    }
  }, "5.您使用的回流炉主要应用在哪些领域？（多选）")])], -1);
});

var _hoisted_38 = {
  class: "bottom"
};

var _hoisted_39 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    style: {
      "margin-right": "10px"
    }
  }, "其它", -1);
});

var _hoisted_40 = ["disabled"];
var _hoisted_41 = {
  class: "zheng"
};

var _hoisted_42 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "one"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "one-right"
  }, [/*#__PURE__*/_createElementVNode("div", {
    style: {
      "margin": "auto"
    }
  }, "6.您认为哪些参数对于回流炉的性能最为关键？（多选）")])], -1);
});

var _hoisted_43 = {
  class: "bottom"
};

var _hoisted_44 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    style: {
      "margin-right": "10px"
    }
  }, "其它", -1);
});

var _hoisted_45 = ["disabled"];
var _hoisted_46 = {
  class: "zheng"
};

var _hoisted_47 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "one"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "one-right"
  }, [/*#__PURE__*/_createElementVNode("div", {
    style: {
      "margin": "auto"
    }
  }, "7.您在使用回流炉过程中遇到过哪些工艺问题？（多选）")])], -1);
});

var _hoisted_48 = {
  class: "bottom"
};

var _hoisted_49 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    style: {
      "margin-right": "10px"
    }
  }, "其它", -1);
});

var _hoisted_50 = ["disabled"];
var _hoisted_51 = {
  class: "zheng"
};

var _hoisted_52 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "one"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "one-right"
  }, [/*#__PURE__*/_createElementVNode("div", {
    style: {
      "margin": "auto"
    }
  }, "8.您在使用回流炉过程中遇到过哪些困难？（多选）")])], -1);
});

var _hoisted_53 = {
  class: "bottom"
};

var _hoisted_54 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    style: {
      "margin-right": "10px"
    }
  }, "其它", -1);
});

var _hoisted_55 = ["disabled"];
var _hoisted_56 = {
  class: "zheng"
};

var _hoisted_57 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "one"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "one-right"
  }, [/*#__PURE__*/_createElementVNode("div", {
    style: {
      "margin": "auto"
    }
  }, "9.贵司需要以下哪些技能优化？（多选）")])], -1);
});

var _hoisted_58 = {
  class: "bottom"
};

var _hoisted_59 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    style: {
      "margin-right": "10px"
    }
  }, "其它", -1);
});

var _hoisted_60 = ["disabled"];
var _hoisted_61 = {
  class: "zheng"
};

var _hoisted_62 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "one"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "one-right"
  }, [/*#__PURE__*/_createElementVNode("div", {
    style: {
      "margin": "auto"
    }
  }, "10.您对哪些服务感兴趣？（多选）")])], -1);
});

var _hoisted_63 = {
  class: "bottom"
};

var _hoisted_64 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "fromstyle-wz"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "wz-nei",
    style: {
      "font-weight": "600"
    }
  }, " 感谢您抽出宝贵的时间参与此次问卷调研，您的热情参与，将共同助力回流焊焊接技术的进步，为电子制造行业的可持续发展贡献您的智慧与经验。 ")], -1);
});

var _hoisted_65 = {
  class: "bottoms"
};
var _hoisted_66 = {
  class: "bottom-btn"
};
var _hoisted_67 = {
  key: 0,
  class: "dibu"
};

var _hoisted_68 = /*#__PURE__*/_createStaticVNode("<div class=\"dibu-kuan\" data-v-8bc19b0c><div data-v-8bc19b0c>本次问卷调研由以下单位共同参与及发起：</div><div class=\"dibu-center\" data-v-8bc19b0c><div class=\"center-wen\" data-v-8bc19b0c><div style=\"margin:auto;\" data-v-8bc19b0c> 跬步磐石（薛广辉工作室） </div></div><div class=\"center-tu\" style=\"margin:0px 20px;\" data-v-8bc19b0c><img src=\"" + _imports_1 + "\" alt=\"\" data-v-8bc19b0c></div><div style=\"width:26%;\" data-v-8bc19b0c><img style=\"width:60%;\" src=\"" + _imports_2 + "\" alt=\"\" data-v-8bc19b0c></div></div><div style=\"display:flex;\" data-v-8bc19b0c><div style=\"margin:auto;\" data-v-8bc19b0c>参与问卷调研，共创未来！感谢您的支持与合作！</div></div></div>", 1);

var _hoisted_69 = [_hoisted_68];
var _hoisted_70 = {
  key: 1,
  class: "dibu"
};

var _hoisted_71 = /*#__PURE__*/_createStaticVNode("<div class=\"dibu-kuan\" data-v-8bc19b0c><div data-v-8bc19b0c>本次问卷调研由以下单位共同参与及发起：</div><div class=\"dibu-center\" data-v-8bc19b0c><div class=\"center-wen\" style=\"margin-top:10px;\" data-v-8bc19b0c><div style=\"margin:auto;\" data-v-8bc19b0c> 跬步磐石（薛广辉工作室） </div></div><div class=\"center-tu\" style=\"margin:0px 10px;\" data-v-8bc19b0c><img src=\"" + _imports_1 + "\" alt=\"\" data-v-8bc19b0c></div><div style=\"margin:5px 0;width:30%;\" data-v-8bc19b0c><img style=\"width:110%;\" src=\"" + _imports_2 + "\" alt=\"\" data-v-8bc19b0c></div></div><div style=\"display:flex;\" data-v-8bc19b0c><div style=\"margin:auto;\" data-v-8bc19b0c>参与问卷调研，共创未来！感谢您的支持与合作！</div></div></div>", 1);

var _hoisted_72 = [_hoisted_71];
var _hoisted_73 = {
  key: 2,
  class: "dibu"
};

var _hoisted_74 = /*#__PURE__*/_createStaticVNode("<div class=\"dibu-kuan\" data-v-8bc19b0c><div data-v-8bc19b0c>本次问卷调研由以下单位共同参与及发起：</div><div class=\"dibu-center\" data-v-8bc19b0c><div class=\"center-tu\" data-v-8bc19b0c><img src=\"" + _imports_1 + "\" alt=\"\" data-v-8bc19b0c></div><div class=\"center-tu1\" data-v-8bc19b0c><img src=\"" + _imports_3 + "\" alt=\"\" data-v-8bc19b0c></div></div><div class=\"dibu-center\" data-v-8bc19b0c><div style=\"margin:auto 0;\" data-v-8bc19b0c> 跬步磐石（薛广辉工作室） </div><div style=\"width:150px;\" data-v-8bc19b0c><img style=\"width:76%;\" src=\"" + _imports_2 + "\" alt=\"\" data-v-8bc19b0c></div></div><div style=\"display:flex;\" data-v-8bc19b0c><div style=\"margin:auto;\" data-v-8bc19b0c>参与问卷调研，共创未来！感谢您的支持与合作！</div></div></div>", 1);

var _hoisted_75 = [_hoisted_74];

var _hoisted_76 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: ""
  })], -1);
});

var _hoisted_77 = [_hoisted_76];
var _hoisted_78 = {
  class: "model"
};

var _hoisted_79 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "zhe"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "zhe-tu"
  }, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    alt: "",
    style: {
      "width": "175px",
      "height": "175px"
    }
  })]), /*#__PURE__*/_createElementVNode("div", {
    class: "zhe-wen"
  }, " 关注公众号，了解更多丰富内容！ ")], -1);
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_input = _resolveComponent("el-input");

  var _component_el_checkbox = _resolveComponent("el-checkbox");

  var _component_el_checkbox_group = _resolveComponent("el-checkbox-group");

  var _component_el_radio = _resolveComponent("el-radio");

  var _component_el_radio_group = _resolveComponent("el-radio-group");

  var _component_el_dialog = _resolveComponent("el-dialog");

  var _component_share = _resolveComponent("share");

  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", {
    class: "main",
    style: _normalizeStyle('padding-top:' + $data.mainpadding + 'px;')
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
    class: _normalizeClass({
      'centerShow': $data.bwidth
    })
  }, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", {
    class: _normalizeClass($data.phoneShow ? 'fromstyle1' : 'fromstyle')
  }, [_hoisted_4, _createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_input, {
    modelValue: $data.bus.company,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $data.bus.company = $event;
    }),
    placeholder: "请输入您的公司名称"
  }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
    modelValue: $data.bus.contact,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return $data.bus.contact = $event;
    }),
    placeholder: "联系人",
    style: {
      "margin": "10px 0px"
    }
  }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
    modelValue: $data.bus.phone,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
      return $data.bus.phone = $event;
    }),
    placeholder: "联系电话"
  }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
    modelValue: $data.bus.position,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
      return $data.bus.position = $event;
    }),
    placeholder: "请输入您的职务",
    style: {
      "margin": "10px 0px"
    }
  }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
    modelValue: $data.bus.email,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
      return $data.bus.email = $event;
    }),
    placeholder: "请输入您的电子邮箱"
  }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("div", _hoisted_11, [_createElementVNode("div", null, [_createVNode(_component_el_checkbox_group, {
    modelValue: $data.dx.multiplechoice1,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) {
      return $data.dx.multiplechoice1 = $event;
    })
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.shData1, function (item, index) {
        return _openBlock(), _createBlock(_component_el_checkbox, {
          label: item.name,
          key: index
        }, null, 8, ["label"]);
      }), 128)), _createVNode(_component_el_checkbox, {
        label: "其它",
        onChange: _cache[6] || (_cache[6] = function ($event) {
          return $options.xz1($event, 1);
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_12, _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
              return $data.tk.suggestions1 = $event;
            }),
            disabled: $options.tk1()
          }, null, 8, _hoisted_13), [[_vModelText, $data.tk.suggestions1]])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["modelValue"])])])]), _createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("div", _hoisted_16, [_createVNode(_component_el_checkbox_group, {
    modelValue: $data.dx.multiplechoice8,
    "onUpdate:modelValue": _cache[10] || (_cache[10] = function ($event) {
      return $data.dx.multiplechoice8 = $event;
    })
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.shData2, function (item, index) {
        return _openBlock(), _createBlock(_component_el_checkbox, {
          label: item,
          key: index
        }, null, 8, ["label"]);
      }), 128)), _createVNode(_component_el_checkbox, {
        label: "其它",
        onChange: _cache[9] || (_cache[9] = function ($event) {
          return $options.xz8($event);
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_17, _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[8] || (_cache[8] = function ($event) {
              return $data.tk.suggestions8 = $event;
            }),
            disabled: $options.tk8()
          }, null, 8, _hoisted_18), [[_vModelText, $data.tk.suggestions8]])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_19, [_hoisted_20, _createElementVNode("div", _hoisted_21, [_createVNode(_component_el_radio_group, {
    modelValue: $data.bus.func,
    "onUpdate:modelValue": _cache[12] || (_cache[12] = function ($event) {
      return $data.bus.func = $event;
    }),
    class: "ml-4",
    onChange: _cache[13] || (_cache[13] = function ($event) {
      return $options.xz2($event);
    })
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_radio, {
        label: "01-10台"
      }, {
        default: _withCtx(function () {
          return [_hoisted_22];
        }),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: "10-20台"
      }, {
        default: _withCtx(function () {
          return [_hoisted_23];
        }),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: "20-40台"
      }, {
        default: _withCtx(function () {
          return [_hoisted_24];
        }),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: "40-60台"
      }, {
        default: _withCtx(function () {
          return [_hoisted_25];
        }),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: "60台以上"
      }, {
        default: _withCtx(function () {
          return [_hoisted_26];
        }),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: "其它"
      }, {
        default: _withCtx(function () {
          return [_hoisted_27, _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[11] || (_cache[11] = function ($event) {
              return $data.tk.suggestions2 = $event;
            }),
            disabled: $options.tk2()
          }, null, 8, _hoisted_28), [[_vModelText, $data.tk.suggestions2]])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_29, [_hoisted_30, _createElementVNode("div", _hoisted_31, [_createVNode(_component_el_radio_group, {
    modelValue: $data.bus.stability,
    "onUpdate:modelValue": _cache[14] || (_cache[14] = function ($event) {
      return $data.bus.stability = $event;
    }),
    class: "ml-4"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_radio, {
        label: "0-1年"
      }, {
        default: _withCtx(function () {
          return [_hoisted_32];
        }),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: "1-3年"
      }, {
        default: _withCtx(function () {
          return [_hoisted_33];
        }),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: "3-5年"
      }, {
        default: _withCtx(function () {
          return [_hoisted_34];
        }),
        _: 1
      }), _createVNode(_component_el_radio, {
        label: "5年以上"
      }, {
        default: _withCtx(function () {
          return [_hoisted_35];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_36, [_hoisted_37, _createElementVNode("div", _hoisted_38, [_createElementVNode("div", null, [_createVNode(_component_el_checkbox_group, {
    modelValue: $data.dx.multiplechoice2,
    "onUpdate:modelValue": _cache[17] || (_cache[17] = function ($event) {
      return $data.dx.multiplechoice2 = $event;
    })
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.shData4, function (item, index) {
        return _openBlock(), _createBlock(_component_el_checkbox, {
          label: item,
          key: index
        }, null, 8, ["label"]);
      }), 128)), _createVNode(_component_el_checkbox, {
        label: "其它",
        onChange: _cache[16] || (_cache[16] = function ($event) {
          return $options.xz3($event);
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_39, _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[15] || (_cache[15] = function ($event) {
              return $data.tk.suggestions3 = $event;
            }),
            disabled: $options.tk3()
          }, null, 8, _hoisted_40), [[_vModelText, $data.tk.suggestions3]])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["modelValue"])])])]), _createElementVNode("div", _hoisted_41, [_hoisted_42, _createElementVNode("div", _hoisted_43, [_createElementVNode("div", null, [_createVNode(_component_el_checkbox_group, {
    modelValue: $data.dx.multiplechoice3,
    "onUpdate:modelValue": _cache[20] || (_cache[20] = function ($event) {
      return $data.dx.multiplechoice3 = $event;
    })
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.shData5, function (item, index) {
        return _openBlock(), _createBlock(_component_el_checkbox, {
          label: item,
          key: index
        }, null, 8, ["label"]);
      }), 128)), _createVNode(_component_el_checkbox, {
        label: "其它",
        onChange: _cache[19] || (_cache[19] = function ($event) {
          return $options.xz4($event);
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_44, _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[18] || (_cache[18] = function ($event) {
              return $data.tk.suggestions4 = $event;
            }),
            disabled: $options.tk4()
          }, null, 8, _hoisted_45), [[_vModelText, $data.tk.suggestions4]])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["modelValue"])])])]), _createElementVNode("div", _hoisted_46, [_hoisted_47, _createElementVNode("div", _hoisted_48, [_createElementVNode("div", null, [_createVNode(_component_el_checkbox_group, {
    modelValue: $data.dx.multiplechoice4,
    "onUpdate:modelValue": _cache[23] || (_cache[23] = function ($event) {
      return $data.dx.multiplechoice4 = $event;
    })
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.shData6, function (item, index) {
        return _openBlock(), _createBlock(_component_el_checkbox, {
          label: item,
          key: index
        }, null, 8, ["label"]);
      }), 128)), _createVNode(_component_el_checkbox, {
        label: "其它",
        onChange: _cache[22] || (_cache[22] = function ($event) {
          return $options.xz5($event);
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_49, _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[21] || (_cache[21] = function ($event) {
              return $data.tk.suggestions5 = $event;
            }),
            disabled: $options.tk5()
          }, null, 8, _hoisted_50), [[_vModelText, $data.tk.suggestions5]])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["modelValue"])])])]), _createElementVNode("div", _hoisted_51, [_hoisted_52, _createElementVNode("div", _hoisted_53, [_createVNode(_component_el_checkbox_group, {
    modelValue: $data.dx.multiplechoice5,
    "onUpdate:modelValue": _cache[26] || (_cache[26] = function ($event) {
      return $data.dx.multiplechoice5 = $event;
    })
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.shData7, function (item, index) {
        return _openBlock(), _createBlock(_component_el_checkbox, {
          label: item,
          key: index
        }, null, 8, ["label"]);
      }), 128)), _createVNode(_component_el_checkbox, {
        label: "其它",
        onChange: _cache[25] || (_cache[25] = function ($event) {
          return $options.xz6($event);
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_54, _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[24] || (_cache[24] = function ($event) {
              return $data.tk.suggestions6 = $event;
            }),
            disabled: $options.tk6()
          }, null, 8, _hoisted_55), [[_vModelText, $data.tk.suggestions6]])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_56, [_hoisted_57, _createElementVNode("div", _hoisted_58, [_createElementVNode("div", null, [_createVNode(_component_el_checkbox_group, {
    modelValue: $data.dx.multiplechoice6,
    "onUpdate:modelValue": _cache[29] || (_cache[29] = function ($event) {
      return $data.dx.multiplechoice6 = $event;
    })
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.shData8, function (item, index) {
        return _openBlock(), _createBlock(_component_el_checkbox, {
          label: item,
          key: index
        }, null, 8, ["label"]);
      }), 128)), _createVNode(_component_el_checkbox, {
        label: "其它",
        onChange: _cache[28] || (_cache[28] = function ($event) {
          return $options.xz7($event);
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_59, _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[27] || (_cache[27] = function ($event) {
              return $data.tk.suggestions7 = $event;
            }),
            disabled: $options.tk7()
          }, null, 8, _hoisted_60), [[_vModelText, $data.tk.suggestions7]])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["modelValue"])])])]), _createElementVNode("div", _hoisted_61, [_hoisted_62, _createElementVNode("div", _hoisted_63, [_createElementVNode("div", null, [_createVNode(_component_el_checkbox_group, {
    modelValue: $data.dx.multiplechoice7,
    "onUpdate:modelValue": _cache[30] || (_cache[30] = function ($event) {
      return $data.dx.multiplechoice7 = $event;
    })
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.shData9, function (item, index) {
        return _openBlock(), _createBlock(_component_el_checkbox, {
          label: item,
          key: index
        }, null, 8, ["label"]);
      }), 128))];
    }),
    _: 1
  }, 8, ["modelValue"])])])]), _hoisted_64], 2), _createElementVNode("div", _hoisted_65, [_createElementVNode("div", _hoisted_66, [_createElementVNode("div", {
    class: "bottom-tj",
    onClick: _cache[31] || (_cache[31] = function ($event) {
      return $options.busAdd(_ctx.ruleFormRef);
    })
  }, " 提交 ")])])]), $data.bwidth ? (_openBlock(), _createElementBlock("div", _hoisted_67, _hoisted_69)) : (_openBlock(), _createElementBlock("div", _hoisted_70, _hoisted_72)), false ? (_openBlock(), _createElementBlock("div", _hoisted_73, _hoisted_75)) : _createCommentVNode("", true)], 2), $data.phoneShow ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "tu",
    onClick: _cache[32] || (_cache[32] = function () {
      return $options.tuShow && $options.tuShow.apply($options, arguments);
    })
  }, _hoisted_77)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_78, [_createVNode(_component_el_dialog, {
    modelValue: $data.imgStatus,
    "onUpdate:modelValue": _cache[33] || (_cache[33] = function ($event) {
      return $data.imgStatus = $event;
    }),
    width: "240px",
    draggable: true,
    "close-on-click-modal": false
  }, {
    default: _withCtx(function () {
      return [_hoisted_79];
    }),
    _: 1
  }, 8, ["modelValue"])])], 4), _createVNode(_component_share, {
    id: 2,
    onChanges: $options.changes
  }, null, 8, ["onChanges"])]);
}